module.exports = __webpack_public_path__ + "img/1010@2x.3aaaa192.png";